export const Forms = {
    locale: 'es',
    messages: {
        es: {
            required: {
                empty: 'Campo obligatorio',
                incorrect: 'Campo obligatorio'
            },
            notzero: {
                empty: 'Selecciona una opción válida',
                incorrect: 'Selecciona una opción válida'
            },
            integer: {
                empty: 'Ingresa un número entero',
                incorrect: 'Ingresa un número entero'
            },
            float: {
                empty: 'Ingresa un número decimal',
                incorrect: 'Ingresa un número decimal'
            },
            min: {
                empty: 'Ingresa un valor mayor a {0}',
                incorrect: 'Ingresa un valor mayor a {0}'
            },
            max: {
                empty: 'Ingresa un valor menor a {0}',
                incorrect: 'Ingresa un valor menor a {0}'
            },
            between: {
                empty: 'Ingresa un valor entre {0}-{1}',
                incorrect: 'Ingresa un valor entre {0}-{1}'
            },
            name: {
                empty: 'Nombre(s) inválido(s)',
                incorrect: 'Nombre(s) inválido(s)'
            },
            lastname: {
                empty: 'Apellidos(s) inválido(s)',
                incorrect: 'Apellidos(s) inválido(s)'
            },
            phone: {
                empty: 'Número telefónico inválido',
                incorrect: 'Número telefónico inválido'
            },
            email: {
                empty: 'Correo inválido',
                incorrect: 'Correo inválido'
            },
            length: {
                empty: 'Por favor, ingresa un mínimo de {0} caracteres y un máximo de {1}',
                incorrect: 'Valor inválido. Ingresa un mínimo de {0} caracteres y un máximo de {1}'
            },
            minlength: {
                empty: 'Por favor, ingresa un mínimo {0} caracteres',
                incorrect: 'Tienes que ingresar por lo menos {0} caracteres'
            },
            maxlength: {
                empty: 'Por favor, ingresa un máximo de {0} caracteres',
                incorrect: 'Tienes que ingresar a lo mucho {0} caracteres'
            },
            maxfilesize: {
                empty: 'El tamaño de uno o mas archivos es mas grande que {0} {1}',
                incorrect: 'El tamaño de uno o mas archivos es mas grande que {0} {1}'
            },
            fileextension: {
                empty: 'Selecciona un archivo',
                incorrect: 'Uno o mas archivos tienen un tipo inválido'
            }
        }
    },
    rules: {
    }
}